import axios from 'axios';
import firebase from 'firebase';
import { RAPID_SOLUTION_ORDER } from '@nexxt/common/constants';
import { getQueryString } from '@nexxt/common/services/TextService';

export const loginProcess = async (
    userCredential: firebase.auth.UserCredential
): Promise<void> => {
    const user = userCredential.user;
    const firebaseIdToken = await user.getIdToken();

    const signinConfig = {
        headers: { Authorization: `Bearer ${firebaseIdToken}` },
        withCredentials: true
    };

    await axios.post(
        `${process.env.INCA_SERVER_URL}/auth/signin`,
        {},
        signinConfig
    );
};

export const getFeaturedRapidSolution = () => {
    return RAPID_SOLUTION_ORDER.includes(getQueryString('rs'))
        ? window.location.search
        : '';
};
